import ConfigParameter, { gettext } from "../ConfigParameter";

export default class FontWeight extends ConfigParameter {

    constructor() {
        super('fontWeight', 'object-select', gettext('Font weight'), 'mainConfig', 'bold', null, [{value: 'normal', label: gettext('Normal')}, {value: 'bold', label: gettext('Bold')}]);
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/FontWeight.js